module.exports = __webpack_public_path__ + "img/sSweetLava_193x205.ffebd02f.png";